export class TextContainsFilter {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "contains",
            "baseName": "contains",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TextContainsFilter.attributeTypeMap;
    }
    constructor() {
    }
}
